export default "/images/doc-icon.png?76fa9fb0fe7874551d9e65b50bc0586b";